import { environment } from '@environments/environment';
import { filterPrice, PriceOrderKey } from '@shared/services/elastic-search/mappings';

export type ModelQueryOptions = {
  from: number;
  size: number;
  sortByWeight: boolean;
  sort?: string;
  front?: string[];
  space?: string[];
  layout?: string[];
  style?: string[];
};

export const GET_KITCHENS_BY_MULTIPLE_FILTERS_QUERY = (langcode: string, options: ModelQueryOptions) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_models,
  body: {
    from: options.from,
    size: options.size,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          ...(options.front
            ? [
                {
                  nested: {
                    path: 'field_visuels_principaux',
                    query: {
                      terms: {
                        'field_visuels_principaux.filters.name.keyword': options.front,
                      },
                    },
                  },
                },
              ]
            : []),
          ...(options.layout ? [{ terms: { implantation_principale: options.layout } }] : []),
          ...(options.space ? [{ terms: { espace: options.space } }] : []),
          ...(options.style ? [{ terms: { style: options.style } }] : []),
        ],
      },
    },
    ...(options.sortByWeight
      ? {
          sort: [
            {
              field_weight: {
                order: 'asc',
              },
            },
          ],
        }
      : options.sort
        ? {
            sort: [
              {
                default_price: {
                  order: filterPrice(options.sort as PriceOrderKey),
                },
              },
            ],
          }
        : {}),
    _source: [
      'nid',
      'nom_modele',
      'default_price_with_currency',
      'default_ecopart_with_currency',
      'field_visuels_principaux',
      'implantation_principale',
      'short_ref',
      'url',
    ],
  },
});
